export default "__VITE_ASSET__bqWc98Y$__"